<template>
  <Loader :loading="httpSend">
    <div class="mb-2"><label>Filtros:</label>
      <div class="row border-bottom border-secondary">
        <div class="col-xl-3 col-sm-6"><label class="card-radio-label mb-3">
          <input type="radio" name="pay-method"
                 id="pay-methodoption1"
                 @change="alterFilter('open')"
                 v-bind:checked="filtro.open"
                 :value="true"
                 v-model="filtro.open"
                 class="card-radio-input">
          <div class="card-radio">
            <i class="fas fa-money-bill font-size-24 text-primary align-middle mr-2"></i>
            <span>Em Aberto</span>
          </div>
        </label>
        </div>
        <div class="col-xl-3 col-sm-6"><label class="card-radio-label mb-3">
          <input type="radio" name="pay-method"
                 @change="alterFilter('all')"
                 id="pay-methodoption3"
                 :value="true"
                 v-model="filtro.all"
                 v-bind:checked="filtro.all"
                 class="card-radio-input">
          <div class="card-radio"><i class="fas fa-money-check-alt font-size-24 text-primary align-middle mr-2"></i>
            <span>Todas as DUAMs</span>
          </div>
        </label>
        </div>
      </div>
    </div>
    <div v-show="!list_guias || list_guias.length < 1" role="alert" aria-live="polite"
         aria-atomic="true" class="alert alert-primary text-center">
      Sem DUAMs
    </div>
    <div v-for="g in list_guias" :key="g.dam_codigo" class="row">
      <div class="col-md-12 mb-3 border-bottom border-secondary">
        <div class="row">
          <div class="col-md-3">
            <b-form-group label="N° da DUAM">
              <h6 class="mb-0">{{ g.dam_codigo }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Competência">
              <h6 class="mb-0">{{ g.dam_mes_ref }}/{{ g.dam_ano_ref }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Tributo">
              <h6 class="mb-0">{{ g.tip_nome }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Situação">
              <h6 class="mb-0">{{ g.tab_nome }}</h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Valor">
              <h6 class="mb-0">{{ g.dut_valortributo | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Atualizações">
              <h6 class="mb-0">{{ g.dut_atualizacao | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Juros">
              <h6 class="mb-0">{{ g.dut_juros | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Multa">
              <h6 class="mb-0">{{ g.dut_multa | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Desconto">
              <h6 class="mb-0">{{ g.dut_desconto | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label-class="text-white" label=".">
              <h6 class="mb-0"></h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Total">
              <h5 class="mb-0 text-danger">{{ g.dut_valortotal | formatNumeroBr }}</h5>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Vencimento">
              <h5 class="mb-0 text-danger">
                {{ g.dam_data_venc_atu | formatDate }}</h5>
            </b-form-group>
          </div>
        </div>
        <div v-if="g.pagamento" class="row">
          <div class="col-md-3">
            <b-form-group label-class="text-white" label=".">
              <h6 class="mb-0"></h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label-class="text-white" label=".">
              <h6 class="mb-0"></h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Valor Pago">
              <h5 class="mb-0 text-success font-weight-bold">{{ g.pagamento.bab_valor_pago | formatNumeroBr }}</h5>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Data de Pagamento">
              <h5 class="mb-0 text-success font-weight-bold">
                {{ g.pagamento.bab_data_pagamento }}</h5>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <span v-show="(g.tab_codigo ==='963' || g.tab_codigo ==='964') && !g.pagamento">
              <button type="button" @click="pagamento(g)"
                      title="Visualizar Guia"
                      class="btn btn-success btn-sm mr-2 mb-2">
              <i class="bx bx-money"></i> Realizar Pagamento
            </button>
              <button v-show="tipo_arrecadacao === 99" type="button" @click="guiaDetalhe(g)" title="Imprimir Guia"
                      class="btn btn-primary btn-sm mr-2 mb-2">
              <i class="bx bx-printer"></i> Espelho da DUAM
            </button>
            </span>
            <button v-show="g.pagamento" type="button" @click="printComprovante(g)" title="Comprovante de Pagamento"
                    class="btn btn-info btn-sm mr-2 mb-2">
              <i class="bx bx-printer"></i> Comprovante de Pagamento
            </button>

            <button type="button" @click="guiaDetalhe(g)" title="Detalhes da DUAM"
                    class="btn btn-dark btn-sm mr-2 mb-2">
              <i class="bx bx-show-alt"></i> Detalhes
            </button>
          </div>
        </div>
      </div>
    </div>
  </Loader>
</template>
<script>
import Loader from "@/components/widgets/loader";
import {listGuias} from "@/api/financeiro/guia";
import {impressao} from "@/helps/impressao";
import {getFinanceiroComprovante} from "@/api/relatorio/financeiro";

export default {
  components: {
    Loader,
  },
  data() {
    return {
      list_guias: [],
      filtro: {
        open: true,
        all: false,
      },
      httpSend: false,
    };
  },
  created() {
    if (this.empresa) {
      this.getGuia();
    }
  },
  computed: {
    tipo_arrecadacao: {
      get: function () {
        return parseInt(this.$store.state.auth.currentEntidade.par_tipo_cobranca);
      },
    },
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
  },
  methods: {
    getGuia() {
      this.httpSend = true;
      listGuias(this.empresa.eco_codigo, this.filtro).then(result => {
        this.list_guias = result.dados
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    alterFilter(tipo) {
      if (tipo === 'open') {
        this.filtro.open = true;
        this.filtro.all = false
      } else {
        this.filtro.open = false;
        this.filtro.all = true
      }
      this.getGuia();
    },
    guiaDetalhe(guia) {
      this.$router.push({
        name: "contribuinte-financeiro-guia-detalhe",
        params: {dam_hash: guia.dam_hash}
      })
    },
    pagamento(guia) {
      this.$router.push({
        name: "contribuinte-financeiro-pagamento",
        params: {dam_hash: guia.dam_hash}
      })
    },
    printComprovante(guia) {
      this.httpSend = true;
      impressao(getFinanceiroComprovante(guia.dam_hash), 'P').catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    }
  }
};
</script>

